
import {defineComponent, PropType} from 'vue';

export default defineComponent({
  props: {
    compact: Boolean,
    direction: {
      default: 'block',
      type: String as PropType<string>,
      validator(value: string) {
        return ['block', 'inline'].includes(value);
      },
    },
  },
});
